module.exports = __webpack_public_path__ + "static/media/fanzone-indicator-icon.0fae9aaf.svg";